/* eslint-disable ember/classic-decorator-hooks, ember/no-controller-access-in-routes, warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';

import { service } from '@ember/service';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import NSWStatus from '@linc-technologies/linced-common/enums/nsw-status';

export default class StaffmemberRoute extends Route {
  // Services
  @service
  router;

  @service
  schoolSchema;

  @service
  session;

  @service
  store;

  model(params) {
    let schema = this.schoolSchema;

    return hash({
      groups: schema.getPeopleSchema(),
      person: this.store.findRecord('person', params.person_id),
      users: this.store.query('user', { personId: params.person_id }),
      locations: this.store
        .query('schools/location', {
          schoolId: this.session.activeSchool,
        })
        .then((locations) => {
          // Filter active locations and then sort by name in ascending order
          return locations
            .filter((location) => location.status === NSWStatus.ACTIVE)
            .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        }),
    });
  }

  init() {
    super.init(...arguments);

    this.router.on('routeWillChange', (transition) => {
      let oldRoute = transition.from
        ? transition.from.find((route) => route.name === this.routeName)
        : false;
      let newRoute = transition.to.find(
        (route) => route.name === this.routeName,
      );
      let oldPersonId = oldRoute ? oldRoute.params.person_id : '';
      let newPersonId = newRoute ? newRoute.params.person_id : '';
      let hasChanged = !newRoute || newPersonId !== oldPersonId;

      if (hasChanged && this.controller) {
        let dirtyFields = this.controller.get(
          'model.person.hasDirtyAttributes',
        );
        let dirtyStaff = this.controller.get(
          'model.person.staff.hasDirtyAttributes',
        );
        if (dirtyFields || dirtyStaff) {
          if (
            window.confirm(
              'You have unsaved changes which will be lost if you leave this page.  Are you sure you wish to leave?',
            )
          ) {
            this.controller.get('model.person').rollbackAttributes();
          } else {
            transition.abort();
          }
        }
      }
    });
  }
}
